<template>
  <div class="onboarding_page">
    <h2>Vill ni aktivera betalningslösningar?</h2>
    <p>Kostar era medlemskap pengar?</p>
    <p style="color: gray; font-style: italic;">Om ja - Betallösningar kommer att aktiveras.</p>
    
    <div class="segmented_select_container">
      <memlist-segmented-select-button 
        :parts="activation_options"
        :primary_color="'rgb(0 123 255)'"
        :secondary_color="'#ffffff'"
        @selected="on_activation_selection"
        :preselected_index="preselected_index"
      />
    </div>
    <div v-if="selected_activation === 'ja'" class="payment_solutions">
      
      <PaymentSettings 
        :company="company"
        ref="payment-settings"
      />

    </div>
    <div class="wizard_actions mt-4">
      <memlist-button variant="secondary" @click="prev_page">Tillbaka</memlist-button>
      <memlist-button variant="primary" :disabled="disabled_next" class="ml-8" @click="next_page">Fortsätt</memlist-button>
    </div>

  </div>
</template>

<script>
import PaymentSettings from '@/view/pages/ml/settings/PaymentSettings.vue';

export default {
  name: 'onboarding_page4',
  props: ['onboarding_data','company'],
  emits: ['next_page','prev_page','update_data'],
  computed: {
    disabled_next() {
      return !this.selected_activation;
    },
  },
  components: {
    PaymentSettings
  },
  watch: {
    onboarding_data: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_onboarding_data = { ...this.onboarding_data };
        this.selected_activation = this.local_onboarding_data.payment_activation;

        const index = this.activation_options.findIndex(i => i.value === this.selected_activation);
        if (index >= 0) {
          this.preselected_index = index;
        }
      },
      immediate: true
    },
    selected_activation() {
      if (this.selected_activation === 'ja') {
        this.$nextTick(()=>{
          this.$refs['payment-settings'].force_payment_select(true);
        });
      }
    },
  },
  
  data() {
    return {
      preselected_index: null,
      local_onboarding_data: null,
      activation_options: [
        { value: 'ja', text: 'Ja' },
        { value: 'nej', text: 'Nej' },
        { value: 'kanske_senare', text: 'Kanske senare' }
      ],
      selected_activation: '',
      solutions: {
        swish: false,
        stripe: false,
        faktura: false
      }
    }
  },
  methods: {
    on_activation_selection(value) {
      this.selected_activation = value
    },
    next_page() {
      this.local_onboarding_data.payment_activation_shown = true;
      this.local_onboarding_data.payment_activation = this.selected_activation;

      this.$emit('update_data', this.local_onboarding_data);
      this.$emit('next_page');
    },
    prev_page() {
      this.$emit('prev_page');
    }
  }
}
</script>

<style lang="scss" scoped>

.segmented_select_container {
  margin: 20px 0;
}

</style>
